import { Injectable } from '@angular/core';
import { ApiWebSubmissionService } from '@core/services/api-web-submission.service';
import { ApiResponse } from '@src/app/core/models/api-response.model';
import { SysParameter } from '@src/app/core/models/sys-parameter.model';
import { Observable } from 'rxjs';
import { UserProfileService } from 'sigv-library';

import { SystemParameter } from '../models/system-parameter.model';

@Injectable()
export class CommonService {
  constructor(
    private apiWebSubmissionService: ApiWebSubmissionService,
    private userService: UserProfileService
  ) {}



 
  getAllSysParameters(
    companyId: string
  ): Observable<ApiResponse<SysParameter[]>> {
    return this.apiWebSubmissionService.doGet(
      '/Common/GetAllSysParameters',
      undefined,
      { 'X-CompanyId': companyId }
    );
  }

  getManySysParameters(
    companyId: string,
    types: string[]
  ): Observable<ApiResponse<SysParameter[]>> {
    return this.apiWebSubmissionService.doPost(
      '/Common/GetManySysParameters',
      types,
      {
        'X-CompanyId': companyId,
      }
    );
  }

  getSystemParameter(
    typeCode: string
  ): Observable<ApiResponse<SystemParameter[]>> {
    return this.apiWebSubmissionService.doGet(
      `/Common/GetSystemParameter/${typeCode}`
    );
  }

  getSystemParameterByParent(
    parentCode: string
  ): Observable<ApiResponse<SystemParameter[]>> {
    return this.apiWebSubmissionService.doGet(
      `/Common/GetSystemParameterByParent/${parentCode}`
    );
  }
}
